import React, { Component } from "react";
import ErrorBoundary from "./ErrorBoundary";
import { paths } from "../../../components/paths";
import { constants } from "../../../utils/Constants";

class ErrorBoundaryContainer extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    console.log(error);
    this.setState({ hasError: true });
  }

  goToHomePage = () => {
    window.location.href = `${window.location.origin}${paths.HOME_PATH}`;
  };

  refreshPage = () => {
    window.location.reload();
  };

  goToC2S2 = () => {
    window.open(constants.C2S2_LINK, "_blank", "noopener");
  };

  render() {
    if (this.state.hasError) {
      return (
        <ErrorBoundary
          refreshPage={this.refreshPage}
          goToHomePage={this.goToHomePage}
          goToC2S2={this.goToC2S2}
        />
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundaryContainer;
